var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEvidence = function SvgIconEvidence(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979AAF",
    stroke: "#979AAF",
    strokeWidth: 0.3,
    d: "M1.35 1c-.19.02-.35.214-.35.423v14.365c0 .221.184.423.386.423h16.228c.202 0 .386-.202.386-.423V1.423C18 1.2 17.816 1 17.614 1H1.35zm.423.845h15.454V13.22l-3.386-4.06c-.078-.09-.195-.14-.308-.132-.052.002-.104.015-.151.04l-5.053 2.766-2.016-2.456c-.086-.107-.223-.16-.35-.139-.04.007-.08.02-.115.04L1.773 11.51V1.845zm7.34 2.535c-1.062 0-1.931.951-1.931 2.113 0 1.161.87 2.112 1.932 2.112 1.062 0 1.931-.95 1.931-2.112 0-1.162-.869-2.113-1.931-2.113zm0 .845c.645 0 1.16.563 1.16 1.268 0 .705-.515 1.267-1.16 1.267-.644 0-1.158-.562-1.158-1.267 0-.705.514-1.268 1.159-1.268zm4.36 4.747l3.754 4.496v.897h-6.006l-2.36-2.878 4.611-2.515zm-7.54.211l4.243 5.182H1.773v-2.904l4.16-2.278z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEvidence, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-evidence.fdee90dd.svg";
export { ForwardRef as ReactComponent };